import React, {useRef, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import t from 'babel-plugin-yate/macro';

import {getTransactionInstallments} from '../../store/transaction';

import Button from '../../components/Button';

import errorFocus from '../../lib/errorFocus';
import ReceivedDetailsForm from '../ReceivedDetailsForm';
import ProductsList from '../ProductsList';
import CancelTransactionButton from '../CancelTransactionButton';

function TransactionStep1(props) {
  const formRef = useRef();
  const dispatch = useDispatch();
  const {data, patchHandler, uuid} = props;

  useEffect(() => {
    dispatch(getTransactionInstallments(uuid));
  }, [dispatch, uuid]);

  return (
    <>
      <div className="lg:flex -ml-10">
        <div className="lg:w-full pl-10">
          <ReceivedDetailsForm
            initialValues={data}
            handleAction={patchHandler}
            disabled={false}
            uuid={uuid}
            formRef={formRef}
            page="Step1"
          />
        </div>

        {data.tx_type === 4 && (
          <div className="lg:w-1/3 pl-10 flex-shrink-0">
            <ProductsList data={data} />
          </div>
        )}
      </div>

      <div className="py-6 flex justify-between">
        <div className="pr-2 flex-shrink-0">
          <CancelTransactionButton uuid={uuid} />
        </div>
        <div className="w-64 mx-auto sm:mr-0">
          <Button
            fullWidth
            color="orange"
            border={false}
            title={t`Continue`}
            onClick={() => {
              errorFocus(formRef.current);

              formRef.current.dispatchEvent(
                new Event(
                  'submit',
                  /**
                   * https://github.com/facebook/react/issues/12639
                   */
                  {cancelable: true},
                ),
              );
            }}
          />
        </div>
      </div>
    </>
  );
}

export default TransactionStep1;
